$(document).ready(function(){

    /* 
        Product Carousel
    */
    var splideOptions = {
      type: 'slide',
      perPage: 4,
      rewind: true,
      arrows: false,
      pagination: false,
      drag: true,
      autoplay: false,
      gap: 15,
      breakpoints: {
        1024: {
          perPage: 3,
          arrows: true
        },
        768: {
          perPage: 2,
          arrows: true
        },
        480: {
          perPage: 1,
          arrows: true
        }
      }
    };
    var elms = document.getElementsByClassName('r-spt-splide');
    for (var i = 0; i < elms.length; i++) 
    {
        new Splide(elms[i], splideOptions).mount();
    }

    /* 
        Banner Carousel
    */
    var BC_splideOptions = {
      type: 'slide',
      perPage: 1,
      rewind: true,
      arrows: false,
      pagination: true,
      drag: true,
      autoplay: false,
      gap: 0
    };
    var elms = document.getElementsByClassName('r-banner-splide');
    for (var i = 0; i < elms.length; i++) 
    {
        new Splide(elms[i], BC_splideOptions).mount();
    }

    /* 
        Hero Banner Carousel
    */
    var HC_splideOptions = {
      type: 'slide',
      perPage: 1,
      rewind: true,
      arrows: false,
      pagination: true,
      drag: true,
      autoplay: true,
      gap: 0
    };
    var elms = document.getElementsByClassName('r-hero-splide');
    for (var i = 0; i < elms.length; i++) 
    {
        new Splide(elms[i], HC_splideOptions).mount();
    }

    /* 
        Tabs
    */
    $(document).on('click', '.r-spt-tab-btn', function(e){
        e.preventDefault();

        let pID     = '#'+$(this).data('open');
        let pCount  = $(this).data('count');
        let pLink   = $(this).data('link');

        $('.r-spt-tab-content').hide();
        $('.r-spt-tab-btn').removeClass('r-open');

        $('.r-spt--count a').text(pCount);
        $('.r-spt--count a').attr('href', pLink);

        $(pID).fadeIn();
        $(this).addClass('r-open');
    });

});